import { Debugger } from '../../utils/index';

export default {
  state: {
    showNotification: false,
    currentNotification: null,
    notifications: [],
    notificationIndex: [],
    notificationHistory: [],
    desktopNotificationPermission: false,
  },
  actions: {
    NEW_NOTIFICATION({ state }, notification) {
      notification.open = true;
      if (state.currentNotification !== null) {
        state.notificationHistory.push(state.currentNotification);
      }
      state.currentNotification = notification;
      state.showNotification = true;
      if (state.notificationIndex.indexOf(JSON.stringify(notification)) === -1) {
        state.notifications.push(notification);
        state.notificationIndex.push(JSON.stringify(notification));
        if (state.desktopNotificationPermission) {
          const pushNotify = (msg) => {
            const pushNotification = new Notification(msg, {
              icon: '/img/logo.e60799c3.png',
            });
            pushNotification.onclick = () => {
              window.focus();
              pushNotification.close();
            };
          };
          if (!document.hasFocus()) {
            pushNotify(notification.msg);
          }
        }
      }
      if (notification.duration) {
        setTimeout(() => {
          state.showNotification = false;
        }, notification.duration);
      }
    },
    HANDLE_DESKTOP_NOTIFICATIONS({ state }) {
      if (!('Notification' in window)) {
        Debugger.log('This browser does not support desktop notification');
      } else if (Notification.permission === 'granted') {
        state.desktopNotificationPermission = true;
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission((permission) => {
          if (permission === 'granted') {
            state.desktopNotificationPermission = true;
          }
        });
      }
    },
  },
};
